module.exports = __webpack_public_path__ + "img/FR11238.40f062eb.svg";